module.exports = __webpack_public_path__ + "static/media/klay_thompson.a30fbfaa.png";